module.exports = __webpack_public_path__ + "img/03—01—02—Combined—WLAN steering.4a83e67b.jpg";